/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
(() => {
  class PDP extends HTMLElement {
    constructor() {
      super();
      this.mobileCrumbs = this.querySelector(".pdp__mobile-bread");
      this.desktopCrumbs = this.querySelector(".pdp__desktop-bread");
    }

    connectedCallback() {
      this.addEventListener("updatedVariant", (e) => {
        this.updateProduct(e.detail);
      });

      this.findBreadcrumbs();
    }

    updateProduct(id) {
      const selectors = [
        ".product-gallery",
        ".product-info__price-info",
        "variant-selectors",
        ".buy-group-pdp",
        ".js-art-nummer",
      ];
      selectors.forEach((selector) => {
        this.querySelector(selector).classList.add("pdp__loading");
      });
      fetch(`${window.location.pathname}/?variant=${id}&section_id=pdp-fetch`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          selectors.forEach((selector) => {
            const targetElement = this.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          });
        })
        .catch(() => {});
    }

    findBreadcrumbs() {
      if (document.querySelector(".breadcrumbs")) {
        this.moveBreadcrumbs();
      } else {
        setTimeout(() => {
          if (document.querySelector(".breadcrumbs")) {
            this.moveBreadcrumbs();
          }
        }, 500);
      }
    }

    moveBreadcrumbs() {
      const breadCrumbs = Array.from(
        document.querySelector(".breadcrumbs").children
      );
      const relevantBreadCrumbs = breadCrumbs.slice(2, -2);

      relevantBreadCrumbs.forEach((child) => {
        if (child.tagName.toLowerCase() === "span") {
          child.className = "";
        }
        if (child.tagName.toLocaleLowerCase() === "a") {
          child.className = "";
          child.classList.add("default-link");
        }

        this.mobileCrumbs.append(child.cloneNode(true));
        this.desktopCrumbs.append(child.cloneNode(true));
      });
    }
  }
  customElements.define("p-d-p", PDP);
})();
